var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keyboard-shortcuts',{attrs:{"show-shortcuts-obj":_vm.showShortcutsObj,"line-data-sets":_vm.lineDataSets}})
}
var staticRenderFns = []

export { render, staticRenderFns }